import React from 'react';
import Portfolio from './components/Portfolio';
import './index.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <Portfolio />
    </div>
  );
}

export default App;